import { Component, SimpleChanges, OnInit, OnChanges, ViewChild, ElementRef, ViewContainerRef, ComponentFactoryResolver, ComponentRef, Input, Output, EventEmitter } from '@angular/core';
// import { MatInput } from '@angular/material';
import { EFormField } from './field';

@Component({
    selector: 'eform-section',
    templateUrl: './section.html',
    styleUrls: ['./section.scss']
  })
export class EFormSection implements OnInit, OnChanges {

    @Input('layout')
    layout: any;

    @Output('change')
    onChange: EventEmitter<{name: string, value: any}> = new EventEmitter<{name: string, value: any}>();

    @ViewChild('section', {static: true, read: ViewContainerRef})
    section: ViewContainerRef;

    constructor(private ref: ElementRef, private componentFactoryResolver: ComponentFactoryResolver) {}

    ngOnInit() {
        this.load();
    }

    ngOnChanges(changes : SimpleChanges) {
        this.load();
    }

    load() {
        if (this.layout.size) {
            this.setSize(this.layout.size);
        }
        this.section.clear();

        for(let control of this.layout.controls) {
            if (control.visible) { 
                this.createControl(control, this.section);
            }
        }
    }

    createControl(ctl: any, parent: ViewContainerRef) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(EFormField);
    
        const componentRef = parent.createComponent(componentFactory);
        componentRef.instance.ctl = ctl;
        componentRef.instance.onChange.subscribe({
            next: (change: {name: string, value: any}) => {

                if (this.layout.target) {
                    this.layout.target[change.name] = change.value;
                }
                this.onChange.emit(change);
            }
        });
        
        // componentRef.instance.type = ctl.datatype || 'text';
        // componentRef.instance.placeholder = ctl.label || ctl.name;
        // componentRef.instance.readonly = ctl.readonly || null;
        // componentRef.instance.disabled = ctl.disabled || !ctl.enabled;
        // componentRef.instance.required = ctl.required || !ctl.optional;

        // (<MatInput>componentRef.instance).value = null;
    }


    setSize(size: number) {
        let el = this.ref.nativeElement;        //section.element.nativeElement.parent;
        el.style.flexGrow = size;
        el.style.minWidth = (size * 3) + 'rem';
        el.style.maxWidth = (size * 9) + 'rem';
    }
}